// Typed wrappers around `/api/staff/teams/*` (feature F-A). Admin-only.

import { getApiClient } from "./client";
import type { components } from "./types";

export type Team = components["schemas"]["TeamResponse"];
export type TeamCreate = components["schemas"]["TeamCreate"];
export type TeamUpdate = components["schemas"]["TeamUpdate"];
export type MessageResponse = components["schemas"]["MessageResponse"];

export async function listTeams(includeDeleted = false): Promise<Team[]> {
  const { data } = await getApiClient().get<Team[]>("/staff/teams", {
    params: includeDeleted ? { include_deleted: true } : {},
  });
  return data;
}

export async function createTeam(payload: TeamCreate): Promise<Team> {
  const { data } = await getApiClient().post<Team>("/staff/teams", payload);
  return data;
}

export async function updateTeam(
  teamId: string,
  payload: TeamUpdate,
): Promise<Team> {
  const { data } = await getApiClient().patch<Team>(
    `/staff/teams/${teamId}`,
    payload,
  );
  return data;
}

export async function deleteTeam(teamId: string): Promise<MessageResponse> {
  const { data } = await getApiClient().delete<MessageResponse>(
    `/staff/teams/${teamId}`,
  );
  return data;
}
